// client/src/routes/app/contracts/$contractId/c168.tsx — SCR-CON-003 tab „C168" · CON-006
// (04 §8.4). The sixth tab CON-005 refused to promise (D-388) and this item lands.
//
// Behind `Fiscal.Read` as well as the parent route's `Leasing.Read`, because everything the tab
// renders comes from `/api/v1/fiscal/obligations` and `/api/v1/fiscal/rule-context`, both of
// which are gated on it (04 §9.2.2: the nav entry is hidden, the typed URL gets SCR-SYS-403 —
// never a redirect). The tab link in the header is hidden for the same reader, so this branch
// answers the URL that was bookmarked or shared rather than clicked.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';
import { C168Panel } from '@/features/contracts/C168Panel';

export const Route = createFileRoute('/app/contracts/$contractId/c168')({
  // Withdrawn from view with the fiscal module (D-2780): the tab is gone, and its address
  // lands on the contract's terms.
  beforeLoad: ({ params }) => {
    if (!fiscalVisible()) throw redirect({ to: '/app/contracts/$contractId', params });
  },
  component: C168TabScreen,
});

function C168TabScreen() {
  const { contractId } = Route.useParams();

  // No `useContract` here, unlike the „Documente" tab: everything this panel renders is keyed
  // by the contract ID alone, and the layout above has already resolved the contract before it
  // renders the outlet — so a second read of the same query would be state this screen does not
  // use, guarded twice.
  return (
    <RequirePermission permission="Fiscal.Read">
      <C168Panel contractId={contractId} />
    </RequirePermission>
  );
}
